import {useQuery} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {coursesUrl} from "../../constants/api/soft-user/endpoints";

interface GetCoursesParams {
  institution_id?: string,
  portfolio_id?: string | null,
  course_code?: string,
  program_id?: string,
  searchValue?: string,
  sortingValue?: string,
  paid?: 'true' | 'false' | 'cart'
  userIsSoft?: boolean,
  only_current_submission_courses?: boolean
  show_recommended?: boolean
}

export const useQueryCourses = (params: GetCoursesParams) => {
  const {
    institution_id,
    portfolio_id,
    course_code,
    program_id,
    searchValue,
    sortingValue,
    paid,
    userIsSoft,
    only_current_submission_courses,
    show_recommended
  } = params;
  const axios = useAxios();

  const handleRequest = () => {
    return axios.get(coursesUrl(userIsSoft), {
      params: {
        institution_id,
        portfolio_id,
        course_code: course_code,
        program_id,
        search_term: searchValue,
        ordering: sortingValue,
        paid,
        only_current_submission_courses,
        show_recommended
      }
    })
      .then(response => response?.data?.data ?? response);
  }

  return useQuery({queryKey: ['courses', program_id, paid], queryFn: handleRequest})

}
